module.exports = __webpack_public_path__ + "save_gold.e889a396ed8d854a9370.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animations/save_gold.gif
// module id = ./src/assets/images/animations/save_gold.gif
// module chunks = main